import { SectionPage } from './SectionPage';
import ContentPreferencesPage from '@/pages/ContentPreferencesPage';

export default function ContentSection() {
  return (
    <SectionPage sectionId="content">
      <ContentPreferencesPage />
    </SectionPage>
  );
}
